const ID_TOKEN_KEY = 'access_token';
const ID_ACCOUNTS = 'accounts';
const ID_SAVE_USER = 'save_user';

export function setSaveUser(saveUser) {
  if (saveUser == null) return;

  window.localStorage.setItem(ID_SAVE_USER, !!saveUser);
}

export function getSaveUser() {
  return JSON.parse(window.localStorage.getItem(ID_SAVE_USER)) ?? true;
}

export function getToken() {
  return (
    window.localStorage.getItem(ID_TOKEN_KEY) ||
    window.sessionStorage.getItem(ID_TOKEN_KEY)
  );
}

export function saveToken(token) {
  if (getSaveUser()) {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
  } else {
    window.sessionStorage.setItem(ID_TOKEN_KEY, token);
  }
}

export function destroyToken() {
  window.localStorage.removeItem(ID_SAVE_USER);
  window.localStorage.removeItem(ID_TOKEN_KEY);
  window.localStorage.removeItem(ID_ACCOUNTS);
  window.sessionStorage.removeItem(ID_TOKEN_KEY);
  window.sessionStorage.removeItem(ID_ACCOUNTS);
}

export function getAccounts(accounts) {
  if (getSaveUser()) {
    return JSON.parse(window.localStorage.getItem(ID_ACCOUNTS));
  } else {
    return JSON.parse(window.sessionStorage.getItem(ID_ACCOUNTS));
  }
}
export function saveAccounts(accounts) {
  if (getSaveUser()) {
    window.localStorage.setItem(ID_ACCOUNTS, JSON.stringify(accounts));
  } else {
    window.sessionStorage.setItem(ID_ACCOUNTS, JSON.stringify(accounts));
  }
}
